//#region Tile button
var tileButtons = {
    eventsNames: {
        startedViewOperation: 'started-view-operation',
        endedViewOperation: 'ended-view-operation'
    },
    getButtonContainer($tileButton) { return $tileButton.closest('.tilebuttons-container') },
    getEventCatcher($tileButton) { return tileButtons.getButtonContainer($tileButton) },
    getIsButtonActive($tileButton) { return $tileButton.find('.tilebutton-body').hasClass('active') },
    /**
     * FIXME, tak nie wolno robic
     * @param {any} $tileButtonContainer
     */
    animateToSmall($tileButtonContainer) {
        $tileButtonContainer.css({
            'height': '0',
            'margin-top': '2.75rem'
        })
        $tileButtonContainer.find('.tilebutton-content').addClass('button-anim-3')
        $tileButtonContainer.find('.tilebutton-icon').addClass('button-anim-1')
        $tileButtonContainer.find('.tilebutton-title').addClass('button-anim-2')
        $tileButtonContainer.find('.tilebutton-container').addClass('button-anim-4')
        $tileButtonContainer.find('.tilebutton-body').css('height', '0')

        $tileButtonContainer.data('isSmallButtonsActivated', true)
        $tileButtonContainer.addClass('tilebuttons-smalled')
    },
    setClickedButtonActive($tileButton) {
        tileButtons.getButtonContainer($tileButton).find(".tilebutton-body.active").removeClass('active')
        $tileButton.find('.tilebutton-body').addClass("active")
    },
    performViewOperation($tileButton) {
        let $container = tileButtons.getButtonContainer($tileButton)

        if ($container.data('isPerformingViewOperations') === true || tileButtons.getIsButtonActive($tileButton) == true) {
            return false
        } else {
            $container.data('isPerformingViewOperations', true)
        }

        let $targetsToShow = $($tileButton.data("targetsToShowSelector"))
        let $targetsToHide = $($tileButton.data("targetsToHideSelector"))

        $targetsToHide.fadeOut({
            duration: 'fast',
            start: function () {
                tileButtons.getEventCatcher($tileButton).trigger(tileButtons.eventsNames.startedViewOperation, [$targetsToShow, $targetsToHide])
            },
            complete: function () {
                $targetsToShow.fadeIn({
                    duration: 'fast',
                    complete: function () {
                        $container.data('isPerformingViewOperations', false)
                        tileButtons.setClickedButtonActive($tileButton)
                        tileButtons.getEventCatcher($tileButton).trigger(tileButtons.eventsNames.endedViewOperation, [$targetsToShow, $targetsToHide])
                    }
                })
            }
        })
    }
}

$(document).on('click', '.custom-tilebutton[data-targets-to-show-selector][data-targets-to-hide-selector]', function () {
    let $btn = $(this)
    let $btnContainer = tileButtons.getButtonContainer($btn)

    if ($btnContainer.data('isSmallButtonsActivated') !== true) {
        tileButtons.animateToSmall($btnContainer)
    }

    tileButtons.performViewOperation($btn)
})

//#endregion Tile button